export default {
	casher: 'Kasiyer',
	manager: 'Müdür',
	name: 'Adı',
	balance: 'Bakiye',
	specify: 'Belirtiniz',
	notDefined: 'Belirtilmemiş',
	operation: 'Operasiyon',
	trade: 'Ticaret',
	gainsAndLosses: 'Kazançlar ve kayıplar',
	budget: 'Bütçe',
	'types-of-final-accounts': {
		notDefined: 'Belirtilmemiş',
		operation: 'Operasiyon',
		trade: 'Ticaret bilgileri',
		'gains-and-losses': 'Kazançlar ve kayıplar',
		budget: 'Bütçe',
		account: 'Hesap'
	},
	'default-account-names': {
		'sales-account': 'Satış hesabı',
		'purchases-account': 'Satın alınlanların hesabı',
		'sales-return-account': 'Satış iade hesabı  ',
		'purchases-return-account': 'Satın alımlar iade hesabı',
		'the-discount-account-granted': 'Satın alınlanların iade hesabı ',
		'earned-discount-account': 'Kazanılan-indirim-hesabı',
		'tax-account': 'Vergi hesabı',
		'cash-customer': 'Nakit müşteri ',
		'default-resource': 'Varsayılan kaynak ',
		'bank-account': 'Banka hesabı',
		'bank-fee-account': 'Banka heasap ücreti',
		'vat-number': 'Vergi numarası',
		'main-cashBoxId': 'Ana kasa',
		'vat-percent': 'Vergi oranı',
		'bank-fee-percent': 'Banka ücret oranı',
		'account-cashboxes-reconciliation': 'Nakit kasaların mutabakat hesabı'
	},
	'store-archive': 'Mağaza arşivi',
	'store-default-settings': 'Mağazanın Varsayılan ayarları',
	reappointment: 'Randevu Yenileme',
	reset: 'Sıfırlama',
	titles: {
		cashboxes: 'Kasa ',
		tax: 'Vergi ',
		'intermediary-accountsId': 'Aracı hesap kimliği ',
		sales: 'Satış',
		purchase: 'Satın alınlanlar',
		bank: 'Banka'
	},
	currency: 'Para birimi',
	'attach-logo': 'Logo ekleyin',
	'import-store-materials': 'Mağaza ürünleri getir ',
	address: 'Adres',
	phone: 'Telefon ',
	// 'please-log-in-to-the-store-context-to-add-settings': '(Please log in to the store context to add settings)',
	'export-item-tree': 'Ürün ağacını dışa aktar  ',
	'import-item-tree': 'Ürün ağacını içe aktar',
	'confirm-import-of-material-tree': 'Ürün ağacının içe aktarımını onaylayınız',
	'are-you-sure-you-want-to-import-the-material-tree-for-the-current-store?': 'Mevcut mağazaya ürün ağacını içe aktarmak istediğinizden emin misiniz?',
	'the-material-tree-import-process-is-irreversible-and-may-take-some-time': 'Ürün ağacı içe aktarma süreci geri döndürülemez ve biraz zaman alabilir',
	tracking: 'Takip',
	'default-language': 'Varsayılan dil',
	importing: 'içe aktarma',
	exporting: 'Dışa aktarma',
	'export-import-tree-item': 'Ağaç ürnünlerini dışa/içe aktarınız',
	language: {
		arabic: 'Arapça',
		english: 'İngilizce',
		spanish: 'İspanyolca'
	},

	'or-import-excel': '/ veya excel tarafından içe aktarın',
	'export-template': 'Şablonu dışa aktar',
	'export-empty-template': 'Boş şablonu dışa aktarma',
	'export-template-with-main-materials': 'Ana ürünleri ile Excel şablonunu dışa aktar',
	'import-materials': 'Ürünleri içe aktarma',
	'import-sub-materials-only': 'Sadece alt malzemeleri içe aktarma',

	'the-import-process-was-successful': 'İçe aktarma işlemi başarılı',
	'the-store-is-materials-file-has-been-successfully-exported-to-the-Downloads-folder': 'Mağaza ürünleri dosyası İndirilenler klasörüne başarıyla aktarıldı',
	'initial-number-of-sales-invoices': 'Satış faturalarının ilk sayısı',
	'your-tax-report-results-will-be-affected': 'Vergi raporu sonuçlarınız etkilenecektir',
	alert: 'Uyarı',
	'store-name-in-reports-(English)': 'Raporlarda Mağaza adı (İngilizce)',
	'store-name-in-reports-(Arabic)': 'Raporlarda Mağaza adı (Arapça)',

	timezone: 'Saat dilimi',
	'printed-invoice-title': 'Basılı fatura başlığı',
	'printed-invoice-type': 'Baskı Fatura Türü',
	'invoice-drafts': 'Fatura taslakları',
	'include-vat-in-price': 'Fiyata KDV ekleme',
	'extra-node': 'Ekstra malzeme ağacı'
}